<template>
  <div v-if="items.length">
    <div class="title-wrap">
      <span class="title">成果展示</span>
      <span v-if="items.length" class="more" @click="gotoWorkList">查看更多</span>
    </div>
    <div class="relative-box">
      <div class="product-box">
        <WorksCard v-for="item in items" :key="item.id" :show-tag="true" class="product-item" :style="computedStyle" :item="item" @click="handleDetail(item)" />
        <div v-if="items.length === 0" class="no-msg">暂无成果展示</div>
      </div>
      <el-button v-if="canMinus" class="left-icon" icon="el-icon-arrow-left" circle @click="minus" />
      <el-button v-if="canAdd" class="right-icon" icon="el-icon-arrow-right" circle @click="add" />
    </div>
  </div>
</template>

<script>
import WorksCard from '@/components/WorksCard'
export default {
  components: {
    WorksCard,
  },
  data() {
    return {
      width: 0,
      index: 0,
      items: [],
    }
  },
  computed: {
    computedStyle() {
      return {
        transform: 'translateX(' + this.width + 'vw)',
      }
    },
    itemsLength() {
      return this.items.length
    },
    canMinus() {
      return this.index !== 0 && this.itemsLength > 4
    },
    canAdd() {
      return this.index < this.itemsLength - 4 && this.itemsLength > 4
    },
  },
  mounted() {
    this.queryWork()
  },
  methods: {
    queryWork() {
      this.$http({ method: 'get', url: '/zzmh/api/showcase/list' }).then((res) => {
        this.items = res.data.list
      })
    },
    gotoWorkList() {
      this.$router.push({
        path: '/work/list',
      })
    },
    handleDetail(item) {
      if (item.showType == 2) {
        window.open(item.jumpUrl, '_blank')
      } else {
        this.$router.push({
          path: '/work/detail?id=' + item.id,
        })
      }
    },
    minus() {
      if (this.canMinus) {
        this.index = this.index - 1
        this.width = this.width + 21.18056
      }
    },
    add() {
      if (this.canAdd) {
        this.index = this.index + 1
        this.width = this.width - 21.18056
      }
    },
  },
}
</script>

<style lang="less" scoped>
@media screen {
  .no-msg {
    margin: 50px 0;
    text-align: center;
    color: #333;
  }
  .product-con {
    position: relative;
    display: flex;
    align-items: center;
  }
  .product-box {
    overflow: hidden;
    white-space: nowrap;
    // .product-item {
    //   display: inline-block;
    //   width: 225px;
    //   height: 179px;
    //   transition: transform 0.4s ease-in-out;
    //   background: #fff;
    //   box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.02);
    //   border-radius: 10px;
    //   transition: all 0.3s;
    //   padding: 20px 30px;
    // }
  }
  .relative-box {
    position: relative;
    .left-icon {
      position: absolute;
      left: -20px;
      top: 50%;
      transform: translateY(-50%);
    }
    .right-icon {
      position: absolute;
      right: -20px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  @media (min-width: 769px) {
  }

  @media (max-width: 768px) {
  }
}
</style>
